import { render, staticRenderFns } from "./PopUp.vue?vue&type=template&id=7d0f059a&"
import script from "./PopUp.vue?vue&type=script&lang=js&"
export * from "./PopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports